async function hasData(file) {
  const text = await file.slice(0, 2048).text();
  const lines = text.split(/\r?\n/);
  return lines.length > 1 && lines[1].trim() !== '';
}

const generateCsvTemplate = () => {
  const headers = [
    'display_name',
    'type',
    'description',
    'solution',
    'address',
    'latitude',
    'longitude',
    'country_code'
  ];
  const exampleRows = [
    [
      'Mall Entrance',
      'entrance_exit',
      'Main entrance to the mall',
      'audience',
      '123 Main St Miami FL',
      '25.76171',
      '-80.19181',
      'US'
    ],
    [
      'Billboard 1',
      'roadside_billboard',
      'Large roadside billboard',
      'traffic',
      '456 Ocean Dr Miami FL',
      '25.79071',
      '-80.13001',
      'US'
    ],
    [
      'Store Display',
      'in_store_display',
      'Display inside retail store',
      'audience_traffic',
      '789 Lincoln Rd Miami FL',
      '25.79011',
      '-80.14001',
      'US'
    ],
    [
      'Charging Kiosk A',
      'charging_kiosks',
      'Charging station near entrance',
      'mobile',
      '321 Collins Ave Miami FL',
      '25.77431',
      '-80.13401',
      'US'
    ],
    [
      'Spectacular Sign',
      'spectacular',
      'Spectacular sign at intersection',
      'traffic',
      '654 Washington Ave Miami FL',
      '25.78002',
      '-80.13501',
      'US'
    ],
    [
      'Retail Store B',
      'retail_store',
      'Retail store main display',
      'audience',
      '987 Alton Rd Miami FL',
      '25.77771',
      '-80.14441',
      'US'
    ],
    [
      'POS Display 1',
      'pos_display',
      'Point of sale display',
      'audience_traffic',
      '1111 Brickell Ave Miami FL',
      '25.76502',
      '-80.19002',
      'US'
    ],
    ['MUPI Ad', 'mupi', 'MUPI advertising unit', 'audience', '2222 Biscayne Blvd', '25.80002', '-80.18501', 'US'],
    [
      'Street Furniture',
      'street_furniture',
      'Bus stop furniture',
      'traffic',
      '3333 NW 36th St Miami FL',
      '25.81301',
      '-80.20001',
      'US'
    ],
    [
      'Large Format Board',
      'large_format',
      'Large format board in parking lot',
      'audience_traffic',
      '4444 NE 2nd Ave Miami FL',
      '25.82002',
      '-80.18002',
      'US'
    ],
    [
      'In-mall Area',
      'in_mall_area',
      'Central area inside mall',
      'mobile',
      '5555 SW 8th St Miami FL',
      '25.76000',
      '-80.21000',
      'US'
    ]
  ];
  const csvContent = [headers]
    .concat(exampleRows)
    .map(row => row.join(','))
    .join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'create_multiple_sites_template.csv';
  a.click();
  URL.revokeObjectURL(url);
};

export { generateCsvTemplate, hasData };
